import React from 'react';
import { useGroupState } from './GroupContext';
import MemberRow from './MemberRow';

import styles from './MembersList.module.scss';

const MembersList = () => {
  const state = useGroupState();

  const members = state?.group?.people || [];

  return (
    <div id={styles.membersListContainer}>
      {members.length === 0 ? (
        <p id={styles.noMembers}>No members found.</p>
      ) : (
        members.map((member) => (
          <MemberRow
            key={member.id || member.path}
            name={member.name}
            path={member.path}
            profilePicturePath={member.profilePicturePath}
          />
        ))
      )}
    </div>
  );
};

export default MembersList;
